<script setup lang="ts">
import NumberInput from '@/uiKit/NumberInput.vue'
/**
 * Renders a number input component, with support for v-model bindings and labels using aria-labeledby.
 *
 * This was originally implemented for relation entity limit in collection properties,
 * so the min-max defaults are preset to support those.
 */

withDefaults(
  defineProps<{
    /** ID of a DOM element containing the label */
    labelId: string
    min?: number
    max?: number
  }>(),
  { min: 1, max: 999 },
)

const model = defineModel<number>({ default: 1 })
const onChange = (value: number) => {
  model.value = value
}
</script>

<template>
  <NumberInput
    :label="{ ariaLabelledBy: `#${labelId}` }"
    :min="min"
    :max="max"
    :value="model"
    name="entity-limit"
    size="xs"
    @change="onChange"
  />
</template>
